import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-thumb-up-icon',
  imports: [],
  templateUrl: './thumb-up-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './thumb-up-icon.component.scss',
})
export class ThumbUpIconComponent {}
